jQuery(document).ready(function($) {
    $('.locations__location').hover(
        function() {
          // On hover in
          var locationId = $(this).data('location-id');
          $('.locations__mapPin[data-location-id="' + locationId + '"]').addClass('locations__mapPin--hover');
        },
        function() {
          // On hover out
          var locationId = $(this).data('location-id');
          $('.locations__mapPin[data-location-id="' + locationId + '"]').removeClass('locations__mapPin--hover');
        }
      );
});